module.exports = __webpack_public_path__ + "static/media/timeIcon.5d6ccd1f.svg";